import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    DamageStatus,
} from 'app/enums/label.enums'

import {
    DamageByContainerType,
} from '../../containers.types'

const columns: RichTableColumns<keyof DamageByContainerType>[] = [
    {
        id: 'damageNumber',
        headerProps: {
            children: 'Damage Number',
        },
        mapCellProps: 'damageNumber',
    },
    {
        id: 'damageTypeName',
        headerProps: {
            children: 'Reason',
        },
        mapCellProps: 'damageTypeName',
        filterField: 'damageTypeName',
        filterType: FilterType.Array,
    },
    {
        id: 'repairingServiceCenter',
        headerProps: {
            children: 'Repairing Service Center',
        },
        mapCellProps: 'repairingServiceCenter',
        filterField: 'repairingServiceCenter',
        filterType: FilterType.Array,
    },
    {
        id: 'reportedOn',
        headerProps: {
            children: 'Reported On (UTC)',
        },
        mapCellProps: 'reportedOn',
        componentName: 'DateTimeCell',
    },
    {
        id: 'repairedOn',
        headerProps: {
            children: 'Repaired On (UTC)',
        },
        mapCellProps: 'repairedOn',
        componentName: 'DateTimeCell',
    },
    {
        id: 'damageStatus',
        headerProps: {
            children: 'Status',
        },
        mapCellProps: 'damageStatus',
        filterField: 'damageStatus',
        filterType: FilterType.Array,
        allowedValuesEnum: DamageStatus,
        componentName: 'EnumValue',
    },
]

export default columns
